var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImagesUserNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "120px",
    height: "120px",
    viewBox: "0 0 120 120",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7AEADC1C-04B9-4440-8496-5057BBE70D9B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M60,0 C68.9713554,0 77.4828315,1.96897705 85.1258634,5.49836615 C82.5331234,8.99130038 81,13.3166101 81,18 C81,29.5979797 90.4020203,39 102,39 C106.68339,39 111.0087,37.4668766 114.501434,34.8751249 C118.031023,42.5171685 120,51.0286446 120,60 C120,93.137085 93.137085,120 60,120 C26.862915,120 0,93.137085 0,60 C0,26.862915 26.862915,0 60,0 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Instagram_account_error",
    transform: "translate(-127, -457)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask-2",
    transform: "translate(0, 417)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(127, 40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#F5F5F5",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,29 C71.0451613,29 80,37.9539171 80,49 C80,60.0460829 71.0451613,69 60,69 C48.9548387,69 40,60.0460829 40,49 C40,37.9539171 48.9548387,29 60,29 M60,161.538462 C82.9410588,161.538462 101.538462,142.941059 101.538462,120 C101.538462,97.0589412 82.9410588,78.4615385 60,78.4615385 C37.0589412,78.4615385 18.4615385,97.0589412 18.4615385,120 C18.4615385,142.941059 37.0589412,161.538462 60,161.538462 Z",
    id: "Combined-Shape",
    fill: "#CCCED4",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FD2545",
    cx: 102,
    cy: 18,
    r: 18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 97,
    y1: 13,
    x2: 107,
    y2: 23,
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 97,
    y1: 13,
    x2: 107,
    y2: 23,
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    transform: "translate(102, 18) scale(-1, 1) translate(-102, -18)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagesUserNotFound);
export default __webpack_public_path__ + "static/media/images_user_not_found.90418ccae854c2108cb065aa51c6ec8d.svg";
export { ForwardRef as ReactComponent };